var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 33 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M30.082 9.216c-2.55-.95-5.55-.367-7.55 1.433a7.383 7.383 0 0 0-4.967-1.9c-4.1 0-7.433 3.35-7.433 7.484 0 4.716 2.367 8.166 4.633 10.4a1.764 1.764 0 0 1-.466-.1C9.982 25.049.332 18.916.332 8.483c0-4.6 3.7-8.317 8.267-8.317 2.716 0 5.116 1.3 6.616 3.317A8.262 8.262 0 0 1 21.832.166c4.567 0 8.267 3.717 8.267 8.317 0 .25 0 .5-.017.733Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.6 13.184c-1-1.333-2.6-2.2-4.4-2.2-3.034 0-5.5 2.467-5.5 5.534 0 1.183.183 2.266.516 3.266 1.567 4.95 6.383 7.9 8.767 8.717.333.117.883.117 1.233 0 2.383-.817 7.2-3.767 8.767-8.717a10.4 10.4 0 0 0 .516-3.266c0-3.067-2.467-5.534-5.5-5.534-1.783 0-3.4.867-4.4 2.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.e5325010f113deead44e2a1962fbc6e7.svg";
export { ForwardRef as ReactComponent };